import Form, { IForm } from "./Form";
import GenderEnum from "@/config/genderEnum"

import registerMandatoryFieldsSet from "@/config/register_form_mandatory.config"
import { CSEService } from "../../service/CSEService";
import locale from "@/state/locale";

export interface IRegisterForm extends IForm {
    gender: GenderEnum
    first_name: string
    last_name: string
    email: string
    password1: string
    password2: string
    address: string
    city: string
    postal_code: string
    country: string
    phone_code: string
    phone_number: string
    subscribe_newsletter?: boolean | undefined
    accept_conditions?: boolean | undefined
    locale: string

    getIsFormValid(): boolean
}

export default class RegisterForm extends Form implements IRegisterForm {
    public gender = GenderEnum.None
    public first_name = ''
    public last_name = ''
    public email: string
    public password1 = ''
    public password2 = ''
    public address = ''
    public city = ''
    public postal_code = ''
    public country = ''
    public phone_code = ''
    public phone_number = ''
    public locale = ''

    public subscribe_newsletter?: boolean | undefined = false
    public accept_conditions?: boolean | undefined = false

    constructor(
        email: string,
        _locale: string | null
    ) {
        super()
        this.email = email

        if (!_locale) throw new Error("locale.value cannot be undefined")
        this.locale = _locale
        const cseService: CSEService = new CSEService(_locale)
        if (cseService.isCSE) cseService.init()
        if (cseService.isCSE && cseService.isCGOS) {
            if (!cseService.firstName || !cseService.lastName) throw new Error("firstName and lastName in CSEService cannot be undefined");
            this.first_name = cseService.firstName
            this.last_name = cseService.lastName

        }
    }

    public getIsFormValid(): boolean {
        if (registerMandatoryFieldsSet.has("gender") && !this.gender) return false
        if (registerMandatoryFieldsSet.has("first_name") && !this.first_name) return false
        if (registerMandatoryFieldsSet.has("last_name") && !this.last_name) return false
        if (registerMandatoryFieldsSet.has("email") && !this.email) return false
        if (registerMandatoryFieldsSet.has("password1") && !this.password1) return false
        if (registerMandatoryFieldsSet.has("password2") && !this.password2) return false
        if (registerMandatoryFieldsSet.has("address") && !this.address) return false
        if (registerMandatoryFieldsSet.has("city") && !this.city) return false
        if (registerMandatoryFieldsSet.has("postal_code") && !this.postal_code) return false
        if (registerMandatoryFieldsSet.has("country") && !this.country) return false
        if (registerMandatoryFieldsSet.has("phone_code") && !this.phone_code) return false
        if (registerMandatoryFieldsSet.has("phone_number") && !this.phone_number) return false
        if (registerMandatoryFieldsSet.has("subscribe_newsletter") && typeof this.subscribe_newsletter !== 'boolean') return false
        if (registerMandatoryFieldsSet.has("accept_conditions") && typeof this.accept_conditions !== 'boolean') return false

        return true
    }

}